import React from 'react';
import { Home, MessageSquare, Phone, FileText } from 'lucide-react';
interface MobileBottomNavProps {
  currentPage: 'dashboard' | 'ai-copilot' | 'all-templates';
  onNavigateToDashboard: () => void;
  onNavigateToAICopilot: () => void;
  onNavigateToDocuments: () => void;
  onRequestCall: () => void;
}
export function MobileBottomNav({
  currentPage,
  onNavigateToDashboard,
  onNavigateToAICopilot,
  onNavigateToDocuments,
  onRequestCall
}: MobileBottomNavProps) {
  return <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-borderColor z-50 safe-area-bottom" data-id="element-500">
      <div className="grid grid-cols-4 h-16" data-id="element-501">
        {/* Dashboard */}
        <button onClick={onNavigateToDashboard} className={`flex flex-col items-center justify-center gap-1 transition-colors ${currentPage === 'dashboard' ? 'text-violetBlue' : 'text-secondary hover:text-primary'}`} data-id="element-502">
          <Home className="w-6 h-6" strokeWidth={currentPage === 'dashboard' ? 2.5 : 2} data-id="element-503" />
          <span className="text-[10px] font-medium" data-id="element-504">Dashboard</span>
        </button>

        {/* LawVo AI */}
        <button onClick={onNavigateToAICopilot} className={`flex flex-col items-center justify-center gap-1 transition-colors ${currentPage === 'ai-copilot' ? 'text-violetBlue' : 'text-secondary hover:text-primary'}`} data-id="element-505">
          <MessageSquare className="w-6 h-6" strokeWidth={currentPage === 'ai-copilot' ? 2.5 : 2} data-id="element-506" />
          <span className="text-[10px] font-medium" data-id="element-507">AI Copilot</span>
        </button>

        {/* Book a Call */}
        <button onClick={onRequestCall} className="flex flex-col items-center justify-center gap-1 text-secondary hover:text-primary transition-colors" data-id="element-508">
          <Phone className="w-6 h-6" strokeWidth={2} data-id="element-509" />
          <span className="text-[10px] font-medium" data-id="element-510">Book a Call</span>
        </button>

        {/* Document Hub */}
        <button onClick={onNavigateToDocuments} className={`flex flex-col items-center justify-center gap-1 transition-colors ${currentPage === 'all-templates' ? 'text-violetBlue' : 'text-secondary hover:text-primary'}`} data-id="element-511">
          <FileText className="w-6 h-6" strokeWidth={currentPage === 'all-templates' ? 2.5 : 2} data-id="element-512" />
          <span className="text-[10px] font-medium" data-id="element-513">Documents</span>
        </button>
      </div>
    </div>;
}